"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _Context = _interopRequireDefault(require("./Context"));

var _createSynthesize = _interopRequireDefault(require("./createSynthesize"));

var _migrateDeprecatedProps = _interopRequireDefault(require("./migrateDeprecatedProps"));

var _useEvent = _interopRequireDefault(require("./useEvent"));

var Composer = function Composer(props) {
  var _migrateDeprecatedPro = (0, _migrateDeprecatedProps["default"])(props, Composer),
      children = _migrateDeprecatedPro.children,
      ponyfillFromProps = _migrateDeprecatedPro.ponyfill; // If we have the parent context, we will use that synthesize() function and its internal queue.


  var _ref = (0, _react.useContext)(_Context["default"]) || {},
      parentPonyfill = _ref.ponyfill,
      parentSynthesize = _ref.synthesize;

  var ponyfill = ponyfillFromProps || parentPonyfill || {
    speechSynthesis: window.speechSynthesis || window.webkitSpeechSynthesis,
    SpeechSynthesisUtterance: window.SpeechSynthesisUtterance || window.webkitSpeechSynthesisUtterance
  }; // If the parent context changed and no longer has a synthesize() function, we will create the queue.
  // This is very unlikely to happen.

  var synthesize = (0, _react.useMemo)(function () {
    return parentSynthesize || (0, _createSynthesize["default"])();
  }, [parentSynthesize]);
  var speechSynthesis = ponyfill.speechSynthesis;

  var _useState = (0, _react.useState)(speechSynthesis.getVoices()),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      voices = _useState2[0],
      setVoices = _useState2[1];

  (0, _useEvent["default"])(speechSynthesis, 'voiceschanged', function () {
    return setVoices(speechSynthesis.getVoices());
  });
  var context = (0, _react.useMemo)(function () {
    return {
      ponyfill: ponyfill,
      synthesize: synthesize,
      voices: voices
    };
  }, [ponyfill, synthesize, voices]);
  return _react["default"].createElement(_Context["default"].Provider, {
    value: context
  }, typeof children === 'function' ? _react["default"].createElement(_Context["default"].Consumer, null, function (context) {
    return children(context);
  }) : children);
};

Composer.defaultProps = {
  children: undefined,
  ponyfill: undefined
};
Composer.propTypes = {
  children: _propTypes["default"].any,
  ponyfill: _propTypes["default"].shape({
    speechSynthesis: _propTypes["default"].any,
    SpeechSynthesisUtterance: _propTypes["default"].any
  })
};
var _default = Composer;
exports["default"] = _default;